import React from 'react';
import { render } from 'react-dom';
import Root from './routes';

import {unregister} from "./registerServiceWorker";

render(<Root />, document.getElementById('root'));
unregister()
